document.addEventListener('DOMContentLoaded', function () {

  // ── INJECT CART DRAWER HTML ──
  var drawerHTML = `
    <div id="abir-cart-overlay" onclick="closeCartDrawer()"></div>
    <div id="abir-cart-drawer">
      <div class="acd-head">
        <span class="acd-title">Your Cart</span>
        <button class="acd-close" onclick="closeCartDrawer()">✕</button>
      </div>
      <div class="acd-items" id="acd-items"></div>
      <div class="acd-foot">
        <div class="acd-total-row">
          <span class="acd-total-label">Total</span>
          <span class="acd-total-price" id="acd-total"></span>
        </div>
        <a href="/checkout" class="acd-checkout">Checkout</a>
        <a href="/cart" class="acd-view-cart">View cart</a>
      </div>
    </div>
    <style>
      #abir-cart-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9998;opacity:0;pointer-events:none;transition:opacity .3s}
      #abir-cart-overlay.show{opacity:1;pointer-events:all}
      #abir-cart-drawer{position:fixed;top:0;right:-420px;width:420px;max-width:100vw;height:100vh;background:#0E0C0A;border-left:1px solid rgba(196,162,85,.2);z-index:9999;display:flex;flex-direction:column;transition:right .35s cubic-bezier(.4,0,.2,1)}
      #abir-cart-drawer.show{right:0}
      .acd-head{display:flex;align-items:center;justify-content:space-between;padding:24px 28px;border-bottom:1px solid rgba(196,162,85,.12)}
      .acd-title{font-family:Inter,sans-serif;font-size:10px;font-weight:300;letter-spacing:.28em;text-transform:uppercase;color:#C4A255}
      .acd-close{background:none;border:none;color:rgba(232,213,168,.4);font-size:16px;cursor:pointer;padding:4px;transition:color .2s}
      .acd-close:hover{color:#F2EDE4}
      .acd-items{flex:1;overflow-y:auto;padding:20px 28px}
      .acd-item{display:grid;grid-template-columns:72px 1fr auto;gap:16px;padding:16px 0;border-bottom:1px solid rgba(196,162,85,.08);align-items:start}
      .acd-item:last-child{border-bottom:none}
      .acd-item-img{width:72px;height:72px;object-fit:cover;background:#1A1208}
      .acd-item-img img{width:100%;height:100%;object-fit:cover;display:block}
      .acd-item-info{display:flex;flex-direction:column;justify-content:center;gap:6px}
      .acd-item-name{font-family:"EB Garamond",Georgia,serif;font-size:16px;color:#F2EDE4;line-height:1.2}
      .acd-item-variant{font-family:Inter,sans-serif;font-size:9px;font-weight:300;letter-spacing:.14em;color:rgba(196,162,85,.5);text-transform:uppercase}
      .acd-item-price{font-family:"EB Garamond",Georgia,serif;font-size:15px;color:#E8D5A8}
      .acd-item-qty-row{display:flex;align-items:center;gap:10px;margin-top:4px}
      .acd-qty-btn{background:none;border:1px solid rgba(196,162,85,.2);color:rgba(232,213,168,.5);width:22px;height:22px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:14px;transition:all .2s;flex-shrink:0}
      .acd-qty-btn:hover{border-color:#C4A255;color:#C4A255}
      .acd-qty-num{font-family:Inter,sans-serif;font-size:11px;color:rgba(232,213,168,.6);min-width:16px;text-align:center}
      .acd-remove{background:none;border:none;color:rgba(232,213,168,.2);font-size:11px;cursor:pointer;padding:2px 0;transition:color .2s;font-family:Inter,sans-serif;letter-spacing:.1em;text-transform:uppercase;margin-top:2px;display:block}
      .acd-remove:hover{color:rgba(200,80,80,.7)}
      .acd-empty{text-align:center;padding:60px 0;font-family:"EB Garamond",Georgia,serif;font-size:16px;font-style:italic;color:rgba(232,213,168,.3)}
      .acd-foot{padding:20px 28px;border-top:1px solid rgba(196,162,85,.12)}
      .acd-total-row{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:20px}
      .acd-total-label{font-family:Inter,sans-serif;font-size:9px;font-weight:300;letter-spacing:.22em;text-transform:uppercase;color:rgba(196,162,85,.5)}
      .acd-total-price{font-family:"EB Garamond",Georgia,serif;font-size:22px;color:#F2EDE4}
      .acd-checkout{display:block;width:100%;background:#C4A255;color:#0E0C0A;font-family:Inter,sans-serif;font-size:10px;font-weight:400;letter-spacing:.22em;text-transform:uppercase;text-align:center;padding:15px;text-decoration:none;transition:opacity .2s;margin-bottom:10px;box-sizing:border-box}
      .acd-checkout:hover{opacity:.85}
      .acd-view-cart{display:block;text-align:center;font-family:Inter,sans-serif;font-size:9px;font-weight:300;letter-spacing:.18em;text-transform:uppercase;color:rgba(232,213,168,.35);text-decoration:none;transition:color .2s;padding:8px}
      .acd-view-cart:hover{color:#C4A255}
      @media(max-width:480px){
        #abir-cart-drawer{width:100vw}
      }
    </style>
  `;
  document.body.insertAdjacentHTML('beforeend', drawerHTML);

  // ── CART DRAWER FUNCTIONS ──
  window.openCartDrawer = function() {
    refreshCartDrawer();
    document.getElementById('abir-cart-drawer').classList.add('show');
    document.getElementById('abir-cart-overlay').classList.add('show');
    document.body.style.overflow = 'hidden';
  };

  window.closeCartDrawer = function() {
    document.getElementById('abir-cart-drawer').classList.remove('show');
    document.getElementById('abir-cart-overlay').classList.remove('show');
    document.body.style.overflow = '';
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartBadges(count) {
    document.querySelectorAll('.abir-cart-count').forEach(function(el) {
      el.textContent = count;
      if (count > 0) { el.classList.add('visible'); }
      else { el.classList.remove('visible'); }
    });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var itemsEl = document.getElementById('acd-items');
        var totalEl = document.getElementById('acd-total');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        updateCartBadges(cart.item_count);
        if (!itemsEl) return;
        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<div class="acd-empty">Your cart is empty.</div>';
          return;
        }
        itemsEl.innerHTML = cart.items.map(function(item, index) {
          var imgHtml = item.image
            ? '<img src="' + item.image + '" alt="' + item.product_title + '">'
            : '';
          var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="acd-item-variant">' + item.variant_title + '</div>'
            : '';
          return '<div class="acd-item">'
            + '<div class="acd-item-img">' + imgHtml + '</div>'
            + '<div class="acd-item-info">'
            + '<div class="acd-item-name">' + item.product_title + '</div>'
            + variantHtml
            + '<div class="acd-item-price">' + formatMoney(item.final_line_price) + '</div>'
            + '<div class="acd-item-qty-row">'
            + '<button class="acd-qty-btn" onclick="updateQty(' + index + ',' + (item.quantity - 1) + ')">−</button>'
            + '<span class="acd-qty-num">' + item.quantity + '</span>'
            + '<button class="acd-qty-btn" onclick="updateQty(' + index + ',' + (item.quantity + 1) + ')">+</button>'
            + '</div>'
            + '<button class="acd-remove" onclick="removeItem(' + index + ')">Remove</button>'
            + '</div>'
            + '</div>';
        }).join('');
      });
  }

  // ── UPDATE QUANTITY ──
  window.updateQty = function(index, newQty) {
    if (newQty < 1) {
      removeItem(index);
      return;
    }
    var updates = {};
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var item = cart.items[index];
        if (!item) return;
        updates[item.key] = newQty;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function() { refreshCartDrawer(); })
      .catch(function(e) { console.error(e); });
  };

  // ── REMOVE ITEM ──
  window.removeItem = function(index) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var item = cart.items[index];
        if (!item) return;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      })
      .then(function() { refreshCartDrawer(); })
      .catch(function(e) { console.error(e); });
  };

  function getVariantId() {
    var variantInput = document.getElementById('selected-variant');
    var idInput = document.querySelector('[name="id"]');
    return variantInput ? variantInput.value : (idInput ? idInput.value : null);
  }

  // ── ADD TO CART ──
  var atcBtn = document.getElementById('abir-atc');
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var variantId = getVariantId();
      if (!variantId) return;
      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        atcBtn.textContent = 'Added';
        setTimeout(function() {
          atcBtn.textContent = 'Add to cart';
          atcBtn.disabled = false;
        }, 2000);
        openCartDrawer();
      })
      .catch(function() {
        atcBtn.textContent = 'Add to cart';
        atcBtn.disabled = false;
      });
    });
  }

  // ── BUY NOW ──
  var buyBtn = document.querySelector('.abir-buy-now');
  if (buyBtn) {
    buyBtn.addEventListener('click', function() {
      var variantId = getVariantId();
      if (!variantId) return;
      buyBtn.textContent = 'Loading...';
      buyBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function() {
        buyBtn.textContent = 'Buy now';
        buyBtn.disabled = false;
      });
    });
  }
  // ── CART ICON CLICK ──
  document.querySelectorAll('a[href="/cart"], .abir-cart-link').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // ── NEWSLETTER ──
  document.querySelectorAll('#footer-newsletter').forEach(function(form) {
    form.addEventListener('submit', function() {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) setTimeout(function() { btn.textContent = 'Done'; }, 200);
    });
  });

});